const supportLang = ["en", "zh"];
const GetLang = () => {
  const urlParam = new URLSearchParams(window.location.search);
  var lang = urlParam.get("lang");
  var winLang = window.navigator.language.substring(0, 2);

  if (lang) {
    return lang;
  }
  //使用視窗語言
  else if (supportLang.includes(winLang)) {
    return winLang;
  }
  //使用預設
  else {
    return supportLang[0];
  }
};
const currentLang = GetLang();
export { currentLang, Localization, Localizator };

const Localizator = (text) => {
  var t = Localization[text][currentLang];
  if (t) {
    return t;
  } else {
    return Localization[text]["en"];
  }
};

const Localization = {
  back: {
    en: "Back",
    zh: "返回",
  },
  about_me: {
    en: "About Me",
    zh: "關於我",
  },
  blog: {
    en: "Blog",
    zh: "部落格",
  },
  job_offer: {
    en: "Hire Me",
    zh: "工作邀約",
  },
  other: {
    en: "Other",
    zh: "其他",
  },
  self_info_title: {
    en: "A self-tought creator.",
    zh: "靠自學夢想成為工程師的學徒。",
  },
  self_info_text: {
    en: "Be Positive, Have Passion On Everything. \nI love drawing, learning, creating. Aiming to make a useful tool for everyone.",
    zh: "積極努力認真向上， 感謝人生所有機遇。\n反正就是打程式、偶爾畫圖、偶爾學習新知。 歡迎一起做遊戲、聊是非。願能成為熱愛程式的笨蛋 目標是做出大家都會想用的工具!",
  },

  all:{
    en:"All",
    zh:"全部" ,
  },

  //Hire Me
  job_intro: {
    en: "you should hire me you should hire me you should hire me",
    zh: "。",
  },
  job_why_context: {
    en: "Passion in learning, Excellent adaptability ,Seeking challenge throungh out every posibility. Adequate experience in Unity, Know front/back end dev well and Familiar with C#/Python project. Adapt fast from making plugin to full project development. Fill with ability, energy , and willing of learning.",
    zh: "熱愛學習，適應力優，且每個過程都在追逐自我突破與挑戰。熟悉Unity開發，通曉前後端製作，與C#、Python獨立專案開發經驗。從製作插件至完整專案開發都能快速上手。具備技術力、創造力與行動力。",
  },
  
  job_what_context: {
    en: "Unity game, procedural effect, plugin, application. Web front/back end design and maintain. Still learning: Web AR/VR , AI related",
    zh: "Unity遊戲、特效、插件、應用軟體開發，網頁前後端製作、維護。正在學習：Web AR/VR、人工智慧AI相關。",
  },
  job_when_context: {
    en: "2023/2 ~ 2023/7 Job founded.",
    zh: "尚無，已找到2023/2 ~ 2023/6的實習企業",
  },
  job_how_context: {
    en: "Contact me with the following email.  For any technical exchange, friend request... please use the bahamut.",
    zh: "請寄信至以下信箱。若要技術交流、訊問的短信請透過巴哈聯繫。",
  },
};
